import * as React from 'react';
import { observer } from 'mobx-react';
import { Button, EButtonType } from '../../../components/action';
import { ECheckoutStatus } from '../../../../../common/interfaces/checkout';
import { PortalCheckoutTermsPAC, PortalCheckoutTermsPBI, PortalCheckoutTermsVIN } from '.';

// Styles
const s = require('./PortalCheckout.css');

// Props
interface IPortalCheckoutTermsProps {
    onApprove: () => void;
    customerIsPBI: boolean;
    customerPaymentTerms: string;
    checkoutStatus: ECheckoutStatus;
}

// Component
@observer
export class PortalCheckoutTerms extends React.Component<IPortalCheckoutTermsProps, {}> {
    private acceptText: string = 'I accept terms of service - place the order';

    public render() {
        return (
            <div className={s.terms}>
                {' '}
                <Button
                    inBox={true}
                    type={
                        this.props.checkoutStatus === ECheckoutStatus.CheckoutError ? EButtonType.Important : EButtonType.Action
                    }
                    onClick={this.handleTermsApproval}
                >
                    {this.acceptText}
                </Button>
                {!this.props.customerIsPBI ? (
                  <div className={s.VINTerms}>
                    <PortalCheckoutTermsVIN />
                  </div>
                ) : null}

                {this.props.customerPaymentTerms && (
                    <div className={s.paymentTerms}>
                        <h2>Payment terms</h2>
                        <h3>{this.props.customerPaymentTerms}</h3>
                    </div>
                )}
                {(this.props.customerIsPBI && <PortalCheckoutTermsPBI />) || <PortalCheckoutTermsPAC />}
                <Button
                    inBox={true}
                    type={
                        this.props.checkoutStatus === ECheckoutStatus.CheckoutError ? EButtonType.Important : EButtonType.Action
                    }
                    onClick={this.handleTermsApproval}
                >
                    {this.acceptText}
                </Button>
            </div>
        );
    }

    private handleTermsApproval = () => {
        this.props.onApprove();
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalCheckout/PortalCheckoutTerms.tsx